<template>
  <div class="marker">
    <div class="marker__hover" v-show="active">
      {{name}}
    </div>
    <div class="marker__icon__shop" v-if="deliver_type === 1">
      <img class="marker__icon__brand" :src="brand_icon" alt=""/>
    </div>
    <div class="marker__icon__aoi" v-if="deliver_type === 2">
      <img class="marker__icon__brand" :src="brand_icon" alt=""/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreMarker',
  data() {
    return {
      active: true,
    };
  },
  props: ['name', 'deliver_type', 'brand_icon'],
};
</script>

<style lang="less">
.marker {
  position: absolute;
  top: 15px;
  color: #666;

  &__hover {
    position: absolute;
    background: #fff;
    padding: 6px 8px;
    white-space: nowrap;
    box-shadow: 0 4px 10px 0 rgba(0,0,0,0.10);
    border-radius: 5px;
    bottom: 38px;
    left: -29px;

    &:after {
      content: '';
      position: absolute;
      display: block;
      width: 8px;
      height: 10px;
      margin-left: 33px;
      background: #fff;
      transform: rotate(45deg);
    }
  }

  &__icon__aoi, &__icon__shop {
    width: 26px;
    height: 29px;
    background-repeat: no-repeat;
    background-size: 26px 29px;
    position: relative;
  }

  &__icon__aoi {
    background-image: url(data:image/png;base64,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);
  }

  &__icon__shop {
    background-image: url(data:image/png;base64,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);
  }
   &__icon__brand {
     border-radius: 50%;
     width: 17px;
     height: auto;
     position: absolute;
     top: 4px;
     left: 4px;
  }
}

// .marker--staticrider {
//   position: absolute;
//   left: -10px;
//   top: -65px;
//   color: #666;
//   .marker__tips--staticrider {
//     background: #fff;
//     padding: 8px 10px;
//     white-space: nowrap;
//     box-shadow: 0 4px 10px 0 rgba(0,0,0,0.10);
//     border-radius: 5px;
//     position: relative;
//     margin-bottom: 10px;
//     &:after {
//       content: '';
//       position: absolute;
//       display: block;
//       width: 10px;
//       height: 10px;
//       background: #fff;
//       transform: rotate(45deg);
//     }
//     .marker__tips__key {
//       color: #009AFF;
//     }
//   }
//   .marker__image--staticrider {
//     width: 44px;
//     height: 66px;
//     background: url('../../../static/images/rider.png');
//     background-repeat: no-repeat;
//     background-size: 44px 66px;
//     position: relative;
//   }
//   .marker__tips--active {
//     animation: active 5s;
//   }
// }
// @keyframes active
// {
//   0% {box-shadow: none}
//   25% {box-shadow: 0px 0px 20px #ff4d62}
//   50% {box-shadow: none}
//   90% {box-shadow: 0px 0px 10px #ff4d62}
//   100% {box-shadow: none}
// }
</style>




// WEBPACK FOOTER //
// src/components/AMap/StoreMarker.vue